const routes = {
  parameters: (): string => `parameters`,
};

export default routes;
